var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:notices"},[(_vm.masquerading)?_c('AdminMasquerade'):_vm._e(),_vm._v(" "),(_vm.$nuxt.isOffline)?_c('OfflineAlert'):_vm._e(),_vm._v(" "),(_vm.showMaintenanceAlert)?_c('MaintenanceAlert'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }